var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElectricitySecondary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.5 49.5C88.5 42.9 86.8 37.8 85.4 34.8C81.6 25.9 74.4 18.8 65.5 14.9C65.5 14.9 65.4 14.8 65.3 14.8C48.7 7.39997 30.9 12.2 20.8 25C15 31.8 11.5 40.6 11.6 50.3C11.6 55.6 12.7 60.7 14.7 65.3C14.8 65.5 14.8 65.7 14.9 65.9C16.7 70.3 19.1 73.4 20.9 75.2C23.7 78.4 27 81.2 30.7 83.3C38 87.9 46.1 89.6 54.9 88.3C60.6 87.6 65.9 85.7 70.6 82.7C77 78.9 81.8 73.4 84.9 66.5C87.2 61.4 88.5 55.6 88.5 49.5Z",
    fill: "#00A997",
    stroke: "#00A997",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9 4.09999C78 3.79999 77.7 3.59999 77.5 3.79999L36.4 45L26.4 55.1H44.7L22.1 95.9C22 96.2 22.3 96.4 22.5 96.2L63.5 55.1L73.5 45H55.3L77.9 4.09999Z",
    fill: "#FEDC5D",
    stroke: "#FEDC5D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2 33.4L35.8 51.8H46.1H53.5L45.3 66.6L63.7 48.2H54.1H46.1L54.2 33.4C54.2 33.4 54.2 33.3 54.2 33.4Z",
    fill: "#FF931E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2 33.4L35.8 51.8H46.1H53.5L45.3 66.6L63.7 48.2H54.1H46.1L54.2 33.4ZM54.2 33.4C54.2 33.4 54.2 33.3 54.2 33.4Z",
    stroke: "#FF931E",
    strokeWidth: 1.1069,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricitySecondary);
export default __webpack_public_path__ + "static/media/electricity-secondary.2de891da21e7078975daff672297e420.svg";
export { ForwardRef as ReactComponent };